import { filterKeyParts, type QueryFilters } from '../core/queryKeyUtils';

export const hrKeys = {
  all: ['hr'] as const,
  bundle: {
    dashboard: (filters?: QueryFilters) =>
      [...hrKeys.all, 'bundle', 'dashboard', ...filterKeyParts(filters)] as const,
  },
  realtimeStats: () => [...hrKeys.all, 'realtime-stats'] as const,
  dashboard: () => [...hrKeys.all, 'dashboard'] as const,
  dashboardSummary: (year: number, month: number) =>
    [...hrKeys.dashboard(), 'summary', year, month] as const,
  employees: () => [...hrKeys.all, 'employees'] as const,
  employeeDetail: (employeeId: number) =>
    [...hrKeys.employees(), 'detail', employeeId] as const,
  employeeComments: (employeeId: number) =>
    [...hrKeys.employees(), 'comments', employeeId] as const,
  geofences: () => [...hrKeys.all, 'geofences'] as const,
  schedules: {
    all: () => [...hrKeys.all, 'schedules'] as const,
    employees: () => [...hrKeys.schedules.all(), 'employees'] as const,
    employeeDetail: (employeeId: number) =>
      [...hrKeys.schedules.all(), 'employee', employeeId] as const,
  },
  groupRates: () => [...hrKeys.all, 'group-rates'] as const,
  messages: {
    all: () => [...hrKeys.all, 'messages'] as const,
    list: (filters?: QueryFilters) =>
      [...hrKeys.messages.all(), 'list', ...filterKeyParts(filters)] as const,
    stats: () => [...hrKeys.messages.all(), 'stats'] as const,
  },
  requests: {
    all: () => [...hrKeys.all, 'requests'] as const,
    list: (filters?: QueryFilters) =>
      [...hrKeys.requests.all(), 'list', ...filterKeyParts(filters)] as const,
    stats: () => [...hrKeys.requests.all(), 'stats'] as const,
  },
  payroll: {
    all: () => [...hrKeys.all, 'payroll'] as const,
    summary: (year: number, month: number) =>
      [...hrKeys.payroll.all(), 'summary', year, month] as const,
    detail: (employeeId: number, year: number, month: number) =>
      [...hrKeys.payroll.all(), 'detail', employeeId, year, month] as const,
  },
} as const;
